(() => {
  const body = document.querySelector('body');
  const windowHeight = window.innerHeight;
  const sectionContent = document.querySelector('.predictiveSearch__content');
  const sectionResults = document.querySelector('.predictiveSearch__results');
  const searchTogglers = document.querySelectorAll('.toggleSearch');
  const searchSection = document.querySelector('.predictiveSearch');
  const searchButtons = document.querySelectorAll('.header__search-button');
  const searchSize = document.querySelector('.predictiveSearch').dataset.searchSize;
  const headerSearchInput = document.querySelector('.header__search input');
  const searchWrapper = document.querySelector('.predictiveSearch__wrapper');
  const headerSearchLink = document.querySelector('.header__search-link');

  document.documentElement.style.setProperty('--window-height', windowHeight + "px");

  function toggleSearch(isOpen) {
    if (isOpen) {
      body.classList.add('overflow', 'search--active');
      searchSection.classList.add('predictiveSearch--active');

      body.addEventListener('click', handleBodyClick);

      if (window.location.href.includes('/search')) {
        search(headerSearchInput.value);
      }
    } else {
      body.classList.remove('overflow', 'search--active');
      searchSection.classList.remove('predictiveSearch--active');

      body.removeEventListener('click', handleBodyClick);
    }
  }

  function handleBodyClick(e) {
    if (!e.target.closest('.predictiveSearch__wrapper') && !e.target.closest('.header__search') && !e.target.closest('.header')) {
      toggleSearch(false);
    }
  }

  async function search(value) {
    try {
      const response = await fetch(`/search/suggest?q=${value}&resources[limit]=${searchSize}&resources[limit_scope]=each&resources[type]=query,product,collection,article,page&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,variants.sku,body,tag&section_id=predictive-search`);

      if (!response.ok) {
        throw new Error('Search error');
      }

      const searchData = new DOMParser().parseFromString(await response.text(), 'text/html');
      const searchResults = searchData.querySelector('.predictiveSearch__results').innerHTML;
      const searchContent = document.querySelector('.predictiveSearch__results');
      const searchLink = searchData.querySelector('.predictiveSearch__search-link');

      searchContent.innerHTML = searchResults;
      sectionContent?.classList.add('predictiveSearch__content--hidden');
      searchLink ? headerSearchLink.href = searchLink.href : '';

      if (
        searchContent.querySelector('.predictiveSearch__titleEmpty')
        || !headerSearchInput.value.length
      ) {
        searchWrapper.classList.remove('predictiveSearch__wrapper--big');

        searchButtons.forEach(button => {
          button.classList.add('disabled');
        });
      } else {
        searchWrapper.classList.add('predictiveSearch__wrapper--big');

        searchButtons.forEach(button => {
          button.classList.remove('disabled');
        });
      }

      if (window.innerWidth > 1024) {
        document.documentElement.style.setProperty('--search-height', `${searchContent ? searchContent.scrollHeight : searchWrapper.scrollHeight}px`);
      }
    } catch (error) {
      console.error(error.message);
    }
  }

  const handleSearchInputKeyup = debounce((e, value) => {
    if (value.length !== 0) {
      search(value);
    }

    if (value.length === 0) {
      sectionContent.classList.remove('predictiveSearch__content--hidden');
      searchWrapper.classList.remove('predictiveSearch__wrapper--big');
      sectionResults.innerHTML = '';

      searchButtons.forEach(button => {
        button.classList.add('disabled');
      });
    }

    if (e.keyCode === 13 || e.code === 'Enter') {
      window.location.href = `/search?q=${headerSearchInput.value}&type=product`;
    }
  }, 500);

  headerSearchInput.addEventListener('keyup', (e) => {
    handleSearchInputKeyup(e, e.currentTarget.value);
  });

  headerSearchInput.addEventListener('blur', () => toggleSearch(true));
  headerSearchInput.addEventListener('focus', () => toggleSearch(true));

  searchTogglers.forEach(searchToggler => {
    searchToggler.addEventListener('click', () => toggleSearch(false));
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1024) {
      const searchWrapper = document.querySelector('.predictiveSearch__wrapper');
      const searchContent = document.querySelector('.predictiveSearch__results');

      document.documentElement.style.setProperty('--search-height', `${searchContent ? searchContent.scrollHeight : searchWrapper.scrollHeight}px`);
    }
  });
})();
